"use client"

import { MemberListProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const MemberList = {
  label: "Tamda Group | Member List",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    description: {
      label: "Description",
      type: "textarea",
    },
    members: {
      label: "Members",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Member ${index + 1}: ${item?.name || "No name"}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        name: {
          label: "Name",
          type: "text",
        },
        position: {
          label: "Position",
          type: "text",
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    title: "THÀNH VIÊN HỘI ĐỒNG QUẢN TRỊ",
    description:
      "Đội ngũ lãnh đạo giàu kinh nghiệm luôn đưa ra các giải pháp thông minh, hướng đến công nghệ, đóng góp tích cực vào sự phát triển của toàn tập đoàn.",
    members: [
      {
        image: "",
        name: "Ông Hoàng Đình Toàn",
        position: "Chủ tịch Hội đồng quản trị",
        link: "#",
      },
      {
        image: "",
        name: "Bà Trịnh Thị Hồng Ngọc",
        position: "Phó Chủ tịch Hội đồng Quản trị",
        link: "#",
      },
      {
        image: "",
        name: "Ông Nguyễn Chí Cường",
        position: "Thành viên Hội đồng Quản trị",
        link: "#",
      },
      {
        image: "",
        name: "Ông Vũ Phương",
        position: "Chủ tịch Ban kiểm soát",
        link: "#",
      },
      {
        image: "",
        name: "Ông Đinh Mạnh Dung",
        position: "Thành viên Ban kiểm soát",
        link: "#",
      },
      {
        image: "",
        name: "Bà Hoàng Thị Giang",
        position: "Thành viên Ban kiểm soát",
        link: "#",
      },
    ],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
} as ComponentConfig<MemberListProps>
